import {ActionReducerMapBuilder, PayloadAction} from '@reduxjs/toolkit';

import {
    ddParametersAdapter,
    selectDdParametersState,
} from '../report-configuration-slice';
import {IReportConfigurationSliceState} from '../report-configuration-types';
import {
    updateDrilldownParameter,
    loadDrilldownParameters,
    deleteDrilldownParameter,
    loadDDChildReportQueryParameters,
} from './dd-parameters-configuration-thunks';
import {IReportDdParameter} from './dd-parameters-configuration-types';

export const createDdParametersExtraReducer = (
    builder: ActionReducerMapBuilder<IReportConfigurationSliceState>,
) => {
    builder.addCase(loadDDChildReportQueryParameters.fulfilled, (state, {payload}) => {
        state.drilldownSettings.ddChildReportQueryParameters = payload.queryParameters;
    });
    builder.addCase(deleteDrilldownParameter.fulfilled, (state, {meta}) => {
        const {id} = meta.arg;
        ddParametersAdapter.removeOne(selectDdParametersState(state), id);
    });
    builder.addCase(updateDrilldownParameter.fulfilled, (state, {payload: newDdDynamicValue}) => {
        ddParametersAdapter.upsertOne(selectDdParametersState(state), newDdDynamicValue);
    });
    builder.addCase(loadDrilldownParameters.fulfilled, (state, {payload}) => {
        ddParametersAdapter.setAll(selectDdParametersState(state), payload);
    });
};

export const createDdDynamicValuesReducer = <S extends IReportConfigurationSliceState>() => ({
    setDdParameter(
        state: S, {payload: ddDynamicValue}: PayloadAction<IReportDdParameter>,
    ) {
        ddParametersAdapter.setOne(selectDdParametersState(state), ddDynamicValue);
    },
    addDdParameters(
        state: S, {payload: newDdDynamicValue}: PayloadAction<IReportDdParameter>,
    ) {
        ddParametersAdapter.addOne(selectDdParametersState(state), newDdDynamicValue);
    },
    setDdParameters(state: S, {payload: newDdDynamicValues}: PayloadAction<IReportDdParameter[]>) {
        ddParametersAdapter.setAll(selectDdParametersState(state), newDdDynamicValues);
    },
});
